import {Accordion} from "react-bootstrap";
import {
    ModerationVerificationPhoto
} from "components/ModerationUserCard/components/ModerationVerification/ModerationVerificationPhoto";
import {useImagePreview} from "utils";
import React, {FC} from "react";
import {ModerationUser} from "interfaces";
import {PhotoDeleteReasonsLabels} from "enums/PhotoDeleteReasons";

interface Props {
    user: ModerationUser
}

export const ModerationArchivePhotos: FC<Props> = ({user}) => {
    const imagePreview = useImagePreview();

    if (!user.deletedPhotos || user.deletedPhotos.length === 0) {
        return null
    }

    return <Accordion key={user.id} className="mt-2" flush>
        <Accordion.Header>Архив фото ({user.deletedPhotos.length})</Accordion.Header>
        <Accordion.Body>
            <div
                style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))',
                    columnGap: '10px',
                    rowGap: '20px'
                }}
            >
                {user.deletedPhotos.map(h => {
                    const link = h?.image[0]?.link;
                    const reason = h?.deletionReason;
                    const deletedBy = h?.deletedByUser;
                    return (
                        <div
                            key={link}
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                position: 'relative',
                                paddingBottom: '10px',
                                borderBottom: '1px solid #e5e5e5'
                            }}
                        >
                            {link && (
                                <ModerationVerificationPhoto
                                    link={link}
                                    onClick={() => imagePreview.open(link, false)}
                                />
                            )}
                            {reason && (
                                <div className="small text-black">
                                    Удалено: {PhotoDeleteReasonsLabels[reason] ?? reason}
                                </div>
                            )}

                            {deletedBy && (
                                <div className="small">{deletedBy.name}</div>
                            )}
                        </div>
                    );
                })}
            </div>

        </Accordion.Body>
    </Accordion>
}